import muster from '@dbk-legacy/muster';
import flow from 'lodash/flow';

export default function calendar(initialState = {}) {
  const state = Object.assign({}, initialState, {
    selectingDate: 'from',
  });

  function toDateBeforeFromRule(values) {
    if (state.selectingDate === 'to'
      && values.toDate
      && values.fromDate
      && values.toDate < values.fromDate) {
      return {
        ...values,
        toDate: state.toDate ? state.toDate : values.fromDate,
        fromDate: values.toDate,
      };
    }

    return values;
  }

  function selectingToRule(values) {
    if (state.selectingDate === 'to') {
      return {
        ...values,
        selectingDate: 'from',
      };
    }

    return values;
  }

  function selectingFromRule(values) {
    if (state.selectingDate === 'from') {
      return {
        ...values,
        toDate: null,
      };
    }

    return values;
  }

  function selectingToFirstRule(values) {
    if (!values.fromDate && values.toDate) {
      const now = new Date();

      return {
        ...values,
        fromDate: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
      };
    }

    return values;
  }

  function toAndFromEqualRule(values) {
    if (values.fromDate && values.toDate && values.fromDate.valueOf() === values.toDate.valueOf()) {
      return {
        ...values,
        toDate: null,
        selectingDate: 'to',
      };
    }

    return values;
  }

  function removeSame(values) {
    const result = {};

    for (const name of Object.getOwnPropertyNames(values)) {
      if (values[name] !== state[name]) {
        result[name] = values[name];
      }
    }

    return result;
  }

  const applyRules = flow(
    toDateBeforeFromRule,
    selectingToRule,
    selectingFromRule,
    selectingToFirstRule,
    toAndFromEqualRule,
    removeSame,
  );

  return muster()
    .match('["fromDate", "toDate", "selectingDate"]', {
      get(requests) {
        return requests.map(({ req, res }) => res.value(state[req.path]));
      },
      set(requests) {
        for (const { req } of requests) {
          state[req.path] = req.value;
        }
        return requests.map(({ res }) => res.ok());
      },
    })
    .path('selectDate', {
      async call({ req }, { set }) {
        const datePath = state.selectingDate === 'from' ? 'fromDate' : 'toDate';
        const toSet = applyRules(Object.assign({}, state, {
          selectingDate: 'to',
          [datePath]: req.args[0],
        }));

        await set(Object.getOwnPropertyNames(toSet).map(path => ({
          path,
          value: toSet[path],
        })));
      },
    });
}
